import SectionHeading from '../../components/SectionHeading';
import RichText from '../../components/RichText';
import Loader from '../../components/Loader';
import useFetch from '../../hooks/useFetch';
import { getProcessSteps } from '../../services/api';

const FALLBACK_STEPS = [
  {
    id: '1',
    step_number: 1,
    title: 'Apply for Wholesale',
    description:
      'Fill out our quick application form with your business information and Amazon seller account details.',
  },
  {
    id: '2',
    step_number: 2,
    title: 'Account Approval',
    description:
      'Our team reviews your application and approves your wholesale account — typically within 24–48 hours.',
  },
  {
    id: '3',
    step_number: 3,
    title: 'Browse & Order',
    description:
      'Access our full product catalog, choose high-ROI SKUs, and place your first wholesale order with ease.',
  },
  {
    id: '4',
    step_number: 4,
    title: 'Ship & Scale',
    description:
      'We ship directly to Amazon FBA centers with full documentation. You grow, we handle the supply chain.',
  },
];

function padStep(n) {
  return String(n).padStart(2, '0');
}

function HowItWorksSection() {
  const { data, loading } = useFetch(() => getProcessSteps(), []);

  if (loading) {
    return (
      <section id="how">
        <div className="section-inner">
          <Loader />
        </div>
      </section>
    );
  }

  const steps =
    Array.isArray(data) && data.length > 0 ? data : FALLBACK_STEPS;

  return (
    <section id="how">
      <div className="section-inner">
        <SectionHeading
          label="Simple Process"
          title="Get Started in 4 Simple Steps"
          sub="From application to your first shipment, we make onboarding fast and straightforward."
        />
        <div className="how-grid">
          {steps.map((step) => (
            <div className="step" key={step.id}>
              <span className="step-num">{padStep(step.step_number)}</span>
              <div className="step-title">{step.title}</div>
              <RichText html={step.description} tag="p" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
